<script setup lang="ts">
defineProps<{
  modelValue: boolean;
  checkboxClass?: string;
}>();
const emit = defineEmits<(e: "change" | "update:modelValue", value: boolean) => void>();
</script>
<template>
  <label class="tw-flex tw-items-center tw-gap-1">
    <span class="tw-grid tw-place-items-center tw-overflow-hidden tw-rounded-sm" :class="checkboxClass">
      <input
        type="checkbox"
        v-bind="$attrs"
        :checked="modelValue"
        @input="emit('update:modelValue', ($event.target as HTMLInputElement).checked)"
        @change="emit('change', ($event.target as HTMLInputElement).checked)"
      />
    </span>
    <slot />
  </label>
</template>
